import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  let navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <h1>Oops!</h1>
      <h4>Something went wrong!</h4>
      <button
        type="button"
        className="btn btn-dark"
        onClick={() => navigate("/")}
      >
        GO HOME
      </button>
    </div>
  );
}
